import { useEndpoint } from './useEndpoint';

export const useClients = () => {
  const {
    data: clients,
    loading,
    error,
    create,
    update,
    remove,
    mutating,
    mutatingError,
    getById,
    reset
  } = useEndpoint('/clients', 'clients');

  return {
    clients,
    loading,
    error,
    getClientById: getById,
    resetClient: reset,
    createClient: create,
    updateClient: update,
    removeClient: remove,
    processing: mutating,
    processingError: mutatingError
  };
};
